import React from 'react';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { SendEmailIcon } from 'assets/icons/SendEmailIcon';
import { SendEmailIconAlt } from 'assets/icons/SendEmailIconAlt';

export const SendEmail = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: SendEmailIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#0CBFE7'
            }
        },
        opened: {
            icon: SendEmailIconAlt,
            iconProps: { borderColor: '#0CBFE7' }
        },
        warning: {
            icon: SendEmailIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions,
    }} />
}
